import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { CASHBACK_MAIN_PAGE_PATH } from "utils/constants/paths";

const CashbackMainPage = Loadable(React.lazy(() => import("./View")));

export const CashbackMainPageRoute: IRouteItem = {
  path: CASHBACK_MAIN_PAGE_PATH,
  element: React.createElement(CashbackMainPage),
  name: "Cashback Main Page",
};
